"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronLeft = _interopRequireDefault(require("@insided/shared/icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var ChevronIcon = function ChevronIcon(_ref) {
  var _onClick = _ref.onClick,
      title = _ref.title,
      className = _ref.className,
      icon = _ref.icon;
  var iconComponents = {
    chevronLeft: (0, _preact.h)(_ChevronLeft.default, {
      width: 24,
      height: 24,
      fill: "currentColor"
    }),
    chevronRight: (0, _preact.h)(_ChevronRight.default, {
      width: 24,
      height: 24,
      fill: "currentColor"
    }),
    chevronDown: (0, _preact.h)(_ChevronDown.default, {
      width: 24,
      height: 24,
      fill: "currentColor"
    }),
    chevronUp: (0, _preact.h)(_ChevronUp.default, {
      width: 24,
      height: 24,
      fill: "currentColor"
    })
  };
  return (0, _preact.h)("span", {
    tabIndex: 0,
    role: "button",
    title: title,
    className: (0, _classnames.default)(className, 'collapse-trigger', 'js-collapse-trigger'),
    onClick: function onClick(e) {
      return _onClick(e);
    },
    onKeyUp: function onKeyUp(e) {
      return e.code === 'Enter' ? _onClick(e) : null;
    }
  }, iconComponents[icon]);
};

var _default = ChevronIcon;
exports.default = _default;